export const urls = {
    TERMS_OF_SERVICE: 'https://www.johnsnowlabs.com/terms-of-service/',
    REFUND_POLICY: 'https://www.johnsnowlabs.com/refund-policy/',
    PRIVACY_POLICY: 'https://www.johnsnowlabs.com/privacy-policy/',
    LINKEDIN: 'https://www.linkedin.com/company/johnsnowlabs',
    YOUTUBE: 'https://www.youtube.com/@JohnSnowLabs',
    INSTAGRAM: 'https://www.instagram.com/johnsnowlabs/',
    TWITTER: 'https://twitter.com/JohnSnowLabs',
    FACEBOOK: 'https://www.facebook.com/JohnSnowLabsInc',
};
